export default {
  hasError: false,
  errorSubMessage: '',
  errorMessage: '',
  errorDetails: {},
  visibleTerminal: false,
  leaveToRoute: null,
  isOnTour: false,
}
